import { ReservationsEndpoint } from "@constants/ApiEndpoints";
import { AxiosInstance } from "axios";
import ReservationAddonModel from "models/Reservations/ReservationAddonModel";
import { sprintf } from "sprintf-js";

export const getByRoomRate =
  (axios: AxiosInstance) =>
  async (
    reservationId: number,
    roomRateId: number
  ): Promise<ReservationAddonModel[]> => {
    return await axios
      .get(
        sprintf(
          ReservationsEndpoint.ROOM_RATE_ADDONS_GET,
          reservationId,
          roomRateId
        )
      )
      .then(({ data }) => data.items);
  };

export const create =
  (axios: AxiosInstance) =>
  async (item: {
    reservationId: number;
    roomRateId: number;
    data: ReservationAddonModel[];
  }): Promise<ReservationAddonModel[]> => {
    return await axios
      .put(
        sprintf(
          ReservationsEndpoint.ROOM_RATE_ADDONS_CREATE,
          item.reservationId,
          item.roomRateId
        ),
        { addons: item.data }
      )
      .then(({ data }) => data);
  };

export const remove =
  (axios: AxiosInstance) =>
  async (data: {
    reservationId: number;
    roomRateId: number;
    actionId: number;
  }): Promise<any> => {
    return await axios
      .delete(
        sprintf(
          ReservationsEndpoint.ROOM_RATE_ADDONS_REMOVE,
          data.reservationId,
          data.roomRateId,
          data.actionId
        )
      )
      .then(({ data }) => data);
  };
